/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Bigdecimal: { input: number; output: number; }
  Float64: { input: number; output: number; }
  Int32: { input: number; output: number; }
  Int64: { input: number; output: number; }
  String1: { input: string; output: string; }
};

export type Accounts = {
  __typename?: 'Accounts';
  accountCode: Scalars['String']['output'];
  bills?: Maybe<Array<Bills>>;
  createdAt: Scalars['String1']['output'];
  defaultLocationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoicingSystemId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  primaryEmail: Scalars['String']['output'];
  primaryName: Scalars['String']['output'];
  primaryPhone: Scalars['String']['output'];
  updatedAt: Scalars['String1']['output'];
};


export type AccountsBillsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BillsOrderByExp>>;
  where?: InputMaybe<BillsBoolExp>;
};

export type AccountsAggExp = {
  __typename?: 'AccountsAggExp';
  _count: Scalars['Int']['output'];
  accountCode: StringAggExp;
  createdAt: DateTime643AggExp;
  defaultLocationId: StringAggExp;
  id: StringAggExp;
  invoicingSystemId: StringAggExp;
  name: StringAggExp;
  primaryEmail: StringAggExp;
  primaryName: StringAggExp;
  primaryPhone: StringAggExp;
  updatedAt: DateTime643AggExp;
};

export type AccountsBoolExp = {
  _and?: InputMaybe<Array<AccountsBoolExp>>;
  _not?: InputMaybe<AccountsBoolExp>;
  _or?: InputMaybe<Array<AccountsBoolExp>>;
  accountCode?: InputMaybe<StringBoolExp>;
  createdAt?: InputMaybe<DateTimeBoolExp>;
  defaultLocationId?: InputMaybe<StringBoolExp>;
  id?: InputMaybe<StringBoolExp>;
  invoicingSystemId?: InputMaybe<StringBoolExp>;
  name?: InputMaybe<StringBoolExp>;
  primaryEmail?: InputMaybe<StringBoolExp>;
  primaryName?: InputMaybe<StringBoolExp>;
  primaryPhone?: InputMaybe<StringBoolExp>;
  updatedAt?: InputMaybe<DateTimeBoolExp>;
};

export type AccountsFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccountsOrderByExp>>;
  where?: InputMaybe<AccountsBoolExp>;
};

export type AccountsOrderByExp = {
  accountCode?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  defaultLocationId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoicingSystemId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  primaryEmail?: InputMaybe<OrderBy>;
  primaryName?: InputMaybe<OrderBy>;
  primaryPhone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

export type BillHolds = {
  __typename?: 'BillHolds';
  billId: Scalars['String']['output'];
  createdAt: Scalars['String1']['output'];
  id: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String1']['output'];
};

export type BillHoldsBoolExp = {
  _and?: InputMaybe<Array<BillHoldsBoolExp>>;
  _not?: InputMaybe<BillHoldsBoolExp>;
  _or?: InputMaybe<Array<BillHoldsBoolExp>>;
  billId?: InputMaybe<StringBoolExp>;
  createdAt?: InputMaybe<DateTime643BoolExp>;
  id?: InputMaybe<StringBoolExp>;
  reason?: InputMaybe<StringBoolExp>;
  updatedAt?: InputMaybe<DateTime643BoolExp>;
};

export type Bills = {
  __typename?: 'Bills';
  account?: Maybe<Accounts>;
  accountId: Scalars['String']['output'];
  billNumber: Scalars['Int32']['output'];
  billTotal: Scalars['Bigdecimal']['output'];
  billVersion: Scalars['Int32']['output'];
  createdAt: Scalars['String1']['output'];
  holds?: Maybe<Array<BillHolds>>;
  id: Scalars['String']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Locations>;
  locationId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  periodEnd: Scalars['String1']['output'];
  periodStart: Scalars['String1']['output'];
  recalculatedAt?: Maybe<Scalars['String1']['output']>;
  serviceAgreementId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['String1']['output'];
};


export type BillsHoldsArgs = {
  where?: InputMaybe<BillHoldsBoolExp>;
};

export type BillsAggExp = {
  __typename?: 'BillsAggExp';
  _count: Scalars['Int']['output'];
  accountId: StringAggExp;
  billNumber: Int32AggExp;
  billTotal: Decimal384AggExp;
  billVersion: Int32AggExp;
  createdAt: DateTime643AggExp;
  id: StringAggExp;
  invoiceId: StringAggExp;
  locationId: StringAggExp;
  name: StringAggExp;
  periodEnd: DateAggExp;
  periodStart: DateAggExp;
  recalculatedAt: DateTime643AggExp;
  serviceAgreementId: StringAggExp;
  status: StringAggExp;
  updatedAt: DateTime643AggExp;
};

export type BillsBoolExp = {
  _and?: InputMaybe<Array<BillsBoolExp>>;
  _not?: InputMaybe<BillsBoolExp>;
  _or?: InputMaybe<Array<BillsBoolExp>>;
  account?: InputMaybe<AccountsBoolExp>;
  accountId?: InputMaybe<StringBoolExp>;
  billNumber?: InputMaybe<Int32BoolExp>;
  billTotal?: InputMaybe<Decimal384BoolExp>;
  billVersion?: InputMaybe<Int32BoolExp>;
  createdAt?: InputMaybe<DateTimeBoolExp>;
  holds?: InputMaybe<BillHoldsBoolExp>;
  id?: InputMaybe<StringBoolExp>;
  invoiceId?: InputMaybe<StringBoolExp>;
  location?: InputMaybe<LocationsBoolExp>;
  locationId?: InputMaybe<StringBoolExp>;
  name?: InputMaybe<StringBoolExp>;
  periodEnd?: InputMaybe<DateBoolExp>;
  periodStart?: InputMaybe<DateBoolExp>;
  recalculatedAt?: InputMaybe<DateTimeBoolExp>;
  serviceAgreementId?: InputMaybe<StringBoolExp>;
  status?: InputMaybe<StringBoolExp>;
  updatedAt?: InputMaybe<DateTimeBoolExp>;
};

export type BillsFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BillsOrderByExp>>;
  where?: InputMaybe<BillsBoolExp>;
};

export type BillsOrderByExp = {
  account?: InputMaybe<AccountsOrderByExp>;
  accountId?: InputMaybe<OrderBy>;
  billNumber?: InputMaybe<OrderBy>;
  billTotal?: InputMaybe<OrderBy>;
  billVersion?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  invoiceId?: InputMaybe<OrderBy>;
  location?: InputMaybe<LocationsOrderByExp>;
  locationId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  periodEnd?: InputMaybe<OrderBy>;
  periodStart?: InputMaybe<OrderBy>;
  recalculatedAt?: InputMaybe<OrderBy>;
  serviceAgreementId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

export type DateAggExp = {
  __typename?: 'DateAggExp';
  _count: Scalars['Int']['output'];
  _count_distinct: Scalars['Int']['output'];
  max: Scalars['String1']['output'];
  min: Scalars['String1']['output'];
};

export type DateBoolExp = {
  _and?: InputMaybe<Array<DateBoolExp>>;
  _eq?: InputMaybe<Scalars['String1']['input']>;
  _gt?: InputMaybe<Scalars['String1']['input']>;
  _gte?: InputMaybe<Scalars['String1']['input']>;
  _in?: InputMaybe<Array<Scalars['String1']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['String1']['input']>;
  _lte?: InputMaybe<Scalars['String1']['input']>;
  _neq?: InputMaybe<Scalars['String1']['input']>;
  _nin?: InputMaybe<Array<Scalars['String1']['input']>>;
  _not?: InputMaybe<DateBoolExp>;
  _or?: InputMaybe<Array<DateBoolExp>>;
};

export type DateTime643AggExp = {
  __typename?: 'DateTime643AggExp';
  _count: Scalars['Int']['output'];
  _count_distinct: Scalars['Int']['output'];
  max: Scalars['String1']['output'];
  min: Scalars['String1']['output'];
};

export type DateTime643BoolExp = {
  _and?: InputMaybe<Array<DateTime643BoolExp>>;
  _eq?: InputMaybe<Scalars['String1']['input']>;
  _gt?: InputMaybe<Scalars['String1']['input']>;
  _gte?: InputMaybe<Scalars['String1']['input']>;
  _in?: InputMaybe<Array<Scalars['String1']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['String1']['input']>;
  _lte?: InputMaybe<Scalars['String1']['input']>;
  _neq?: InputMaybe<Scalars['String1']['input']>;
  _nin?: InputMaybe<Array<Scalars['String1']['input']>>;
  _not?: InputMaybe<DateTime643BoolExp>;
  _or?: InputMaybe<Array<DateTime643BoolExp>>;
};

export type DateTimeBoolExp = {
  _and?: InputMaybe<Array<DateTimeBoolExp>>;
  _eq?: InputMaybe<Scalars['String1']['input']>;
  _gt?: InputMaybe<Scalars['String1']['input']>;
  _gte?: InputMaybe<Scalars['String1']['input']>;
  _in?: InputMaybe<Array<Scalars['String1']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['String1']['input']>;
  _lte?: InputMaybe<Scalars['String1']['input']>;
  _neq?: InputMaybe<Scalars['String1']['input']>;
  _nin?: InputMaybe<Array<Scalars['String1']['input']>>;
  _not?: InputMaybe<DateTimeBoolExp>;
  _or?: InputMaybe<Array<DateTimeBoolExp>>;
};

export type Decimal384AggExp = {
  __typename?: 'Decimal384AggExp';
  _count: Scalars['Int']['output'];
  _count_distinct: Scalars['Int']['output'];
  avg: Scalars['Float64']['output'];
  max: Scalars['Bigdecimal']['output'];
  min: Scalars['Bigdecimal']['output'];
  stddev_pop: Scalars['Float64']['output'];
  stddev_samp: Scalars['Float64']['output'];
  sum: Scalars['Bigdecimal']['output'];
  var_pop: Scalars['Float64']['output'];
  var_samp: Scalars['Float64']['output'];
};

export type Decimal384BoolExp = {
  _and?: InputMaybe<Array<Decimal384BoolExp>>;
  _eq?: InputMaybe<Scalars['Bigdecimal']['input']>;
  _gt?: InputMaybe<Scalars['Bigdecimal']['input']>;
  _gte?: InputMaybe<Scalars['Bigdecimal']['input']>;
  _in?: InputMaybe<Array<Scalars['Bigdecimal']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Bigdecimal']['input']>;
  _lte?: InputMaybe<Scalars['Bigdecimal']['input']>;
  _neq?: InputMaybe<Scalars['Bigdecimal']['input']>;
  _nin?: InputMaybe<Array<Scalars['Bigdecimal']['input']>>;
  _not?: InputMaybe<Decimal384BoolExp>;
  _or?: InputMaybe<Array<Decimal384BoolExp>>;
};

export type Int32AggExp = {
  __typename?: 'Int32AggExp';
  _count: Scalars['Int']['output'];
  _count_distinct: Scalars['Int']['output'];
  avg: Scalars['Float64']['output'];
  max: Scalars['Int32']['output'];
  min: Scalars['Int32']['output'];
  stddev_pop: Scalars['Float64']['output'];
  stddev_samp: Scalars['Float64']['output'];
  sum: Scalars['Int64']['output'];
  var_pop: Scalars['Float64']['output'];
  var_samp: Scalars['Float64']['output'];
};

export type Int32BoolExp = {
  _and?: InputMaybe<Array<Int32BoolExp>>;
  _eq?: InputMaybe<Scalars['Int32']['input']>;
  _gt?: InputMaybe<Scalars['Int32']['input']>;
  _gte?: InputMaybe<Scalars['Int32']['input']>;
  _in?: InputMaybe<Array<Scalars['Int32']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int32']['input']>;
  _lte?: InputMaybe<Scalars['Int32']['input']>;
  _neq?: InputMaybe<Scalars['Int32']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int32']['input']>>;
  _not?: InputMaybe<Int32BoolExp>;
  _or?: InputMaybe<Array<Int32BoolExp>>;
};

export type Inventories = {
  __typename?: 'Inventories';
  _no_fields_accessible?: Maybe<Scalars['String']['output']>;
};

export type InventoriesAggExp = {
  __typename?: 'InventoriesAggExp';
  _count: Scalars['Int']['output'];
};

export type InventoriesBoolExp = {
  _and?: InputMaybe<Array<InventoriesBoolExp>>;
  _not?: InputMaybe<InventoriesBoolExp>;
  _or?: InputMaybe<Array<InventoriesBoolExp>>;
};

export type InventoriesFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InventoriesOrderByExp>>;
  where?: InputMaybe<InventoriesBoolExp>;
};

export type InventoriesOrderByExp = {
  _no_fields_accessible?: InputMaybe<Scalars['String']['input']>;
};

export type Locations = {
  __typename?: 'Locations';
  accountId: Scalars['String']['output'];
  createdAt: Scalars['String1']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  locationAddress1: Scalars['String']['output'];
  locationAddress2?: Maybe<Scalars['String']['output']>;
  locationCity?: Maybe<Scalars['String']['output']>;
  locationCountry: Scalars['String']['output'];
  locationPostcode: Scalars['String']['output'];
  locationState?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['String1']['output'];
  warehouseLocationId?: Maybe<Scalars['String']['output']>;
};

export type LocationsAggExp = {
  __typename?: 'LocationsAggExp';
  _count: Scalars['Int']['output'];
  accountId: StringAggExp;
  createdAt: DateTime643AggExp;
  externalId: StringAggExp;
  id: StringAggExp;
  locationAddress1: StringAggExp;
  locationAddress2: StringAggExp;
  locationCity: StringAggExp;
  locationCountry: StringAggExp;
  locationPostcode: StringAggExp;
  locationState: StringAggExp;
  name: StringAggExp;
  status: StringAggExp;
  type: StringAggExp;
  updatedAt: DateTime643AggExp;
  warehouseLocationId: StringAggExp;
};

export type LocationsBoolExp = {
  _and?: InputMaybe<Array<LocationsBoolExp>>;
  _not?: InputMaybe<LocationsBoolExp>;
  _or?: InputMaybe<Array<LocationsBoolExp>>;
  accountId?: InputMaybe<StringBoolExp>;
  createdAt?: InputMaybe<DateTimeBoolExp>;
  externalId?: InputMaybe<StringBoolExp>;
  id?: InputMaybe<StringBoolExp>;
  locationAddress1?: InputMaybe<StringBoolExp>;
  locationAddress2?: InputMaybe<StringBoolExp>;
  locationCity?: InputMaybe<StringBoolExp>;
  locationCountry?: InputMaybe<StringBoolExp>;
  locationPostcode?: InputMaybe<StringBoolExp>;
  locationState?: InputMaybe<StringBoolExp>;
  name?: InputMaybe<StringBoolExp>;
  status?: InputMaybe<StringBoolExp>;
  type?: InputMaybe<StringBoolExp>;
  updatedAt?: InputMaybe<DateTimeBoolExp>;
  warehouseLocationId?: InputMaybe<StringBoolExp>;
};

export type LocationsFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<LocationsOrderByExp>>;
  where?: InputMaybe<LocationsBoolExp>;
};

export type LocationsOrderByExp = {
  accountId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  externalId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  locationAddress1?: InputMaybe<OrderBy>;
  locationAddress2?: InputMaybe<OrderBy>;
  locationCity?: InputMaybe<OrderBy>;
  locationCountry?: InputMaybe<OrderBy>;
  locationPostcode?: InputMaybe<OrderBy>;
  locationState?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  warehouseLocationId?: InputMaybe<OrderBy>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _no_fields_accessible?: Maybe<Scalars['String']['output']>;
};

export enum OrderBy {
  /** Sorts the data in ascending order */
  Asc = 'Asc',
  /** Sorts the data in descending order */
  Desc = 'Desc'
}

export type Query = {
  __typename?: 'Query';
  accounts?: Maybe<Array<Accounts>>;
  accountsAggregate?: Maybe<AccountsAggExp>;
  bills?: Maybe<Array<Bills>>;
  billsAggregate?: Maybe<BillsAggExp>;
  inventories?: Maybe<Array<Inventories>>;
  inventoriesAggregate?: Maybe<InventoriesAggExp>;
  locations?: Maybe<Array<Locations>>;
  locationsAggregate?: Maybe<LocationsAggExp>;
  skus?: Maybe<Array<Skus>>;
  skusAggregate?: Maybe<SkusAggExp>;
};


export type QueryAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccountsOrderByExp>>;
  where?: InputMaybe<AccountsBoolExp>;
};


export type QueryAccountsAggregateArgs = {
  filter_input?: InputMaybe<AccountsFilterInput>;
};


export type QueryBillsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BillsOrderByExp>>;
  where?: InputMaybe<BillsBoolExp>;
};


export type QueryBillsAggregateArgs = {
  filter_input?: InputMaybe<BillsFilterInput>;
};


export type QueryInventoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InventoriesOrderByExp>>;
  where?: InputMaybe<InventoriesBoolExp>;
};


export type QueryInventoriesAggregateArgs = {
  filter_input?: InputMaybe<InventoriesFilterInput>;
};


export type QueryLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<LocationsOrderByExp>>;
  where?: InputMaybe<LocationsBoolExp>;
};


export type QueryLocationsAggregateArgs = {
  filter_input?: InputMaybe<LocationsFilterInput>;
};


export type QuerySkusArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SkusOrderByExp>>;
  where?: InputMaybe<SkusBoolExp>;
};


export type QuerySkusAggregateArgs = {
  filter_input?: InputMaybe<SkusFilterInput>;
};

export type Skus = {
  __typename?: 'Skus';
  _no_fields_accessible?: Maybe<Scalars['String']['output']>;
};

export type SkusAggExp = {
  __typename?: 'SkusAggExp';
  _count: Scalars['Int']['output'];
};

export type SkusBoolExp = {
  _and?: InputMaybe<Array<SkusBoolExp>>;
  _not?: InputMaybe<SkusBoolExp>;
  _or?: InputMaybe<Array<SkusBoolExp>>;
};

export type SkusFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SkusOrderByExp>>;
  where?: InputMaybe<SkusBoolExp>;
};

export type SkusOrderByExp = {
  _no_fields_accessible?: InputMaybe<Scalars['String']['input']>;
};

export type StringAggExp = {
  __typename?: 'StringAggExp';
  _count: Scalars['Int']['output'];
  _count_distinct: Scalars['Int']['output'];
};

export type StringBoolExp = {
  _and?: InputMaybe<Array<StringBoolExp>>;
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _match?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  _nlike?: InputMaybe<Scalars['String']['input']>;
  _not?: InputMaybe<StringBoolExp>;
  _or?: InputMaybe<Array<StringBoolExp>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  accounts?: Maybe<Array<Accounts>>;
  accountsAggregate?: Maybe<AccountsAggExp>;
  bills?: Maybe<Array<Bills>>;
  billsAggregate?: Maybe<BillsAggExp>;
  inventories?: Maybe<Array<Inventories>>;
  inventoriesAggregate?: Maybe<InventoriesAggExp>;
  locations?: Maybe<Array<Locations>>;
  locationsAggregate?: Maybe<LocationsAggExp>;
  skus?: Maybe<Array<Skus>>;
  skusAggregate?: Maybe<SkusAggExp>;
};


export type SubscriptionAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AccountsOrderByExp>>;
  where?: InputMaybe<AccountsBoolExp>;
};


export type SubscriptionAccountsAggregateArgs = {
  filter_input?: InputMaybe<AccountsFilterInput>;
};


export type SubscriptionBillsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BillsOrderByExp>>;
  where?: InputMaybe<BillsBoolExp>;
};


export type SubscriptionBillsAggregateArgs = {
  filter_input?: InputMaybe<BillsFilterInput>;
};


export type SubscriptionInventoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InventoriesOrderByExp>>;
  where?: InputMaybe<InventoriesBoolExp>;
};


export type SubscriptionInventoriesAggregateArgs = {
  filter_input?: InputMaybe<InventoriesFilterInput>;
};


export type SubscriptionLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<LocationsOrderByExp>>;
  where?: InputMaybe<LocationsBoolExp>;
};


export type SubscriptionLocationsAggregateArgs = {
  filter_input?: InputMaybe<LocationsFilterInput>;
};


export type SubscriptionSkusArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SkusOrderByExp>>;
  where?: InputMaybe<SkusBoolExp>;
};


export type SubscriptionSkusAggregateArgs = {
  filter_input?: InputMaybe<SkusFilterInput>;
};

export type BillsQueryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where: BillsBoolExp;
  orderBy: Array<BillsOrderByExp> | BillsOrderByExp;
}>;


export type BillsQueryQuery = { __typename?: 'Query', bills?: Array<{ __typename?: 'Bills', id: string, name?: string | null, billNumber: number, billTotal: number, status: string, periodStart: string, periodEnd: string, recalculatedAt?: string | null, createdAt: string, accountId: string, account?: { __typename?: 'Accounts', id: string, name: string } | null, location?: { __typename?: 'Locations', id: string, name: string } | null, holds?: Array<{ __typename?: 'BillHolds', id: string, billId: string, reason?: string | null, createdAt: string, updatedAt: string }> | null }> | null, billsAggregate?: { __typename?: 'BillsAggExp', _count: number } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const BillsQueryDocument = new TypedDocumentString(`
    query BillsQuery($limit: Int!, $offset: Int!, $where: BillsBoolExp!, $orderBy: [BillsOrderByExp!]!) {
  bills(limit: $limit, offset: $offset, where: $where, order_by: $orderBy) {
    id
    name
    billNumber
    billTotal
    status
    periodStart
    periodEnd
    recalculatedAt
    createdAt
    accountId
    account {
      id
      name
    }
    location {
      id
      name
    }
    holds {
      id
      billId
      reason
      createdAt
      updatedAt
    }
  }
  billsAggregate(filter_input: {where: $where}) {
    _count
  }
}
    `) as unknown as TypedDocumentString<BillsQueryQuery, BillsQueryQueryVariables>;